module.exports = __webpack_public_path__ + "static/media/empy-cart.1d0d5c7d.svg";